import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { Menu} from "../Types/types";
import { RootState } from "../../Core/Store";
import { useAppDispatch } from "../../Core/store.hooks";

const initialState: Menu = {
  isOpen: true,
};

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    toggleMenu: (state, action: PayloadAction<Menu>) => {
      return action.payload;
    },
  },
});

export const { toggleMenu } = menuSlice.actions;

export const getMenuStatusSelector = (state: Menu) =>
  state.menu.isOpen;

export default menuSlice.reducer;
